import React, { useEffect, useState } from 'react';
import SideNav from './SideNav';
import { getUserInformation } from '../../../api/usersApi';
import ExperienceMainMenu from '../mainMenu/ProfessionalExperience/ExperienceMainMenu';
import EducationMainMenu from '../mainMenu/Education/EducationMainMenu';
import SkillMainMenu from '../mainMenu/Skills/SkillsMainMenu';
import LanguageMainMenu from '../mainMenu/Language/LanguageMainMenu';
import PersonalInfoMainMenu from '../mainMenu/PersonalInfo/PersonalInfoMainMenu';
import ReferenceMainMenu from '../mainMenu/Reference/ReferenceMainMenu';
import CertificationMainMenu from '../mainMenu/Certification/CertificationMainMenu';
import { toast } from 'react-toastify';
import { COMPLETE_CURRICULUM_VITAE_ITEM_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy } from '../../../service/toastService';
import { createCurriculumVitaeLanguage, updateCurriculumVitaeLanguage, deleteCurriculumVitaeLanguage,
    createCurriculumVitaeEducation, updateCurriculumVitaeEducation, deleteCurriculumVitaeEducation,
    createCurriculumVitaeSkill, updateCurriculumVitaeSkill, deleteCurriculumVitaeSkill,
    createCurriculumVitaeExperience, updateCurriculumVitaeExperience, deleteCurriculumVitaeExperience, 
    deleteCurriculumVitaeCertification,
    createCurriculumVitaeReference,
    updateCurriculumVitaeReference,
    deleteCurriculumVitaeReference} from '../../../api/curriculumVitaeApi';

const TABS = [
    { id: 'personalInfo', title: 'Personal Info'},
    { id: 'work', title: 'Work Experience' },
    { id: 'education', title: 'Education' },
    { id: 'skills', title: 'Skills' },
    { id: 'languages', title: 'Languages' },
    { id: 'references', title: 'References'},
    { id: 'certifications', title: 'Certifications'}
];

function CvMainMenu({ curriculumVitae, setCurriculumVitae, currentLoggedUserId }) {
    const [activeTab, setActiveTab] = useState(TABS[0].id);
    const [user, setUser] = useState(null);
    const wizardCompleted = true;

    useEffect(() => {
        const fetchLoggedInUser = async () => {
            if (!currentLoggedUserId) return;
    
            const response = await getUserInformation(currentLoggedUserId);
            setUser(response);  
        };
    
        fetchLoggedInUser();
    }, [currentLoggedUserId]);
        
    const handleSaveItem = async (itemData, type) => {
        try {
            let updatedItems;
            
            if (itemData.id) {
                const updatedItem = await updateItem(itemData, type);
                updatedItems = curriculumVitae[type].map(item => 
                    item.id === itemData.id ? updatedItem.data : item
                );
            } else {
                const newItem = await createItem(itemData, type);
                updatedItems = [...curriculumVitae[type], newItem.data];
            }
    
            setCurriculumVitae(prevCv => ({
                ...prevCv,
                [type]: updatedItems
            }));
    
            toast.success(`Item saved successfully!`, getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_ITEM_TOAST_MESSAGES));
        } catch (error) {
            toast.error(`Failed to save item. Try again.`, getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_ITEM_TOAST_MESSAGES));
        }
    };
    
    const handleDeleteItem = async (itemId, type) => {
        try {
            await deleteItem(itemId, type);
    
            setCurriculumVitae(prevCv => ({
                ...prevCv,
                [type]: prevCv[type].filter(item => item.id !== itemId)
            }));
    
            toast.success(`Item deleted successfully!`, getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_ITEM_TOAST_MESSAGES));
        } catch (error) {
            toast.error(`Failed to delete item. Try again.`, getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_ITEM_TOAST_MESSAGES));
        }
    };
    
    const createItem = (itemData, type) => {
        const apiMap = {
            curriculumVitaeLanguages: createCurriculumVitaeLanguage,
            curriculumVitaeEducations: createCurriculumVitaeEducation,
            curriculumVitaeSkills: createCurriculumVitaeSkill,
            curriculumVitaeExperiences: createCurriculumVitaeExperience,
            curriculumVitaeReferences: createCurriculumVitaeReference,
        };
        return apiMap[type](itemData);
    };
    
    const updateItem = (itemData, type) => {
        const apiMap = {
            curriculumVitaeLanguages: updateCurriculumVitaeLanguage,
            curriculumVitaeEducations: updateCurriculumVitaeEducation,
            curriculumVitaeSkills: updateCurriculumVitaeSkill,
            curriculumVitaeExperiences: updateCurriculumVitaeExperience,
            curriculumVitaeReferences: updateCurriculumVitaeReference,

        };
        return apiMap[type](itemData);
    };
    
    const deleteItem = (itemId, type) => {
        const apiMap = {
            curriculumVitaeLanguages: deleteCurriculumVitaeLanguage,
            curriculumVitaeEducations: deleteCurriculumVitaeEducation,
            curriculumVitaeSkills: deleteCurriculumVitaeSkill,
            curriculumVitaeExperiences: deleteCurriculumVitaeExperience,
            curriculumVitaeCertifications: deleteCurriculumVitaeCertification,
            curriculumVitaeReferences: deleteCurriculumVitaeReference,
        };
        return apiMap[type](itemId);
    };
    
    const renderContent = () => {
        switch (activeTab) {
            case 'personalInfo':
                return <PersonalInfoMainMenu currentLoggedUserId={currentLoggedUserId} wizardCompleted={wizardCompleted} />
            case 'work':
                return <ExperienceMainMenu 
                        curriculumVitae={curriculumVitae} 
                        setCurriculumVitae={setCurriculumVitae} 
                        handleSaveItem={handleSaveItem} 
                        handleDeleteItem={handleDeleteItem} 
                        status={curriculumVitae.status} />;
            case 'education':
                return <EducationMainMenu 
                        curriculumVitae={curriculumVitae} 
                        setCurriculumVitae={setCurriculumVitae} 
                        handleSaveItem={handleSaveItem} 
                        handleDeleteItem={handleDeleteItem} 
                        status={curriculumVitae.status} />;
            case 'skills':
                return <SkillMainMenu 
                        curriculumVitae={curriculumVitae} 
                        setCurriculumVitae={setCurriculumVitae} 
                        handleDeleteItem={handleDeleteItem} 
                        status={curriculumVitae.status} />;
            case 'languages':
                return <LanguageMainMenu 
                        curriculumVitae={curriculumVitae} 
                        setCurriculumVitae={setCurriculumVitae} 
                        handleSaveItem={handleSaveItem} 
                        handleDeleteItem={handleDeleteItem} 
                        status={curriculumVitae.status} />;
            case 'references':
                return <ReferenceMainMenu 
                        curriculumVitae={curriculumVitae} 
                        setCurriculumVitae={setCurriculumVitae} 
                        handleSaveItem={handleSaveItem} 
                        handleDeleteItem={handleDeleteItem} 
                        status={curriculumVitae.status}/>
            case 'certifications':
                return <CertificationMainMenu 
                        curriculumVitae={curriculumVitae} 
                        setCurriculumVitae={setCurriculumVitae} 
                        handleSaveItem={handleSaveItem} 
                        handleDeleteItem={handleDeleteItem} 
                        status={curriculumVitae.status} />
            default:
                return null;
        }
    };

    return (
        <>
          <div className="cv-main-menu-titles">
            <h1>Curriculum Vitae</h1>
            <h4>Summary</h4>
          </div>
            <div className="cv-overview-container">
              {user && (
                  <SideNav
                      curriculumVitae={curriculumVitae}
                      user={user} tabs={TABS}
                      activeTab={activeTab}
                      onSelect={setActiveTab} />
                )}
                <div className="cv-overview-content">{renderContent()}</div>
            </div>
        </>
    );
}

export default CvMainMenu;
